import axios from "axios";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Button, Input } from "reactstrap";
import Moment from "react-moment";
import { callMessageNotification } from "store/Message/actions";
import createUserSelector from "store/users/selector";
import socket from "socket/socket";

const MessageReply = ({ notification, allLoginCustomer, isReplyOpen, setIsReplyOpen }) => {
    const dispatch = useDispatch();
    const userSelector = useSelector(createUserSelector);
    const { loginUser } = userSelector;
    const [isLoading, setIsLoading] = useState(false);
    const [replyText, setReplyText] = useState("");

    const toggleReply = () => {
        setIsReplyOpen((prev) => !prev);
        setReplyText("");
    };

    const handleMessageReply = async (messageId) => {
        if (!replyText.trim()) {
            toast.error("Reply cannot be empty!");
            return;
        }

        setIsLoading(true);

        if (messageId && loginUser?._id) {
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_BACKEND_URL}/twilio/message/${messageId}/reply`,
                    {
                        sender: loginUser._id,
                        messageContent: replyText.trim(),
                    }
                );

                if (response.status === 200) {
                    dispatch(callMessageNotification(true));
                    socket.emit('message:reply', {
                        messageId,
                    });
                    toast.success(response.data.message || "Reply sent successfully.");
                    toggleReply();
                } else {
                    toast.error(response.data.message || "Failed to send reply.");
                }
            } catch (error) {
                console.error("Error:", error);
                toast.error("An error occurred while sending the reply.");
            } finally {
                setIsLoading(false);
            }
        } else {
            toast.error("Invalid message or user data.");
            setIsLoading(false);
        }
    };

    return (
        <div className="message-reply-container">
            {/* Reply button or count */}
            <Button
                onClick={toggleReply}
                className="border-0 fw-bold text-start p-0 reply-toggle-btn"
                color="none"
            >
                {notification?.replies?.length > 0
                    ? `${notification.replies.length} Replies`
                    : "Reply"}
            </Button>

            {/* Replies list and input box */}
            {isReplyOpen && (
                <div className="reply-section">
                    {/* Render existing replies */}
                    {notification?.replies?.length > 0 && (
                        <div className="reply-list">
                            {notification.replies.map((reply, index) => {
                                const userName =
                                    allLoginCustomer.find(
                                        (user) => String(user._id) === String(reply.sender)
                                    )?.name || "N/A";

                                const loginUserName = String(loginUser?._id) === String(reply.sender) ? 'You' : userName;
                                return <div
                                    key={index}
                                    className="reply-item border rounded p-2 mb-2"
                                >
                                    <div>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <p className="fw-bolder mb-0">{loginUserName}</p>
                                            <small className="text-muted">
                                                <Moment fromNow>{reply.timestamp}</Moment>
                                            </small>
                                        </div>
                                        <p className="reply-content text-secondary mb-0">{reply.messageContent}</p>
                                    </div>

                                </div>
                            })}
                        </div>
                    )}

                    {/* Input for new reply */}
                    <div className="reply-input-container">
                        <Input
                            type="textarea"
                            className="reply-input mb-2"
                            placeholder="Write your reply..."
                            value={replyText}
                            onChange={(e) => setReplyText(e.target.value)}
                            disabled={isLoading}
                        />
                        <div className="d-flex justify-content-between">
                            <Button
                                color="link"
                                size="sm"
                                onClick={toggleReply}
                                disabled={isLoading}
                            >
                                Cancel
                            </Button>
                            <Button
                                color="dark rounded-4"
                                size="sm"
                                onClick={() => handleMessageReply(notification?._id)}
                                disabled={isLoading || !replyText.trim()}
                            >
                                {isLoading ? "Sending..." : "Reply"}
                            </Button>
                        </div>
                    </div>
                </div>
            )
            }
        </div >
    );
};

export default MessageReply;
